import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba6dddc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-phone-number-container" }
const _hoisted_2 = {
  key: 0,
  class: "remaining-time"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], { title: "휴대폰 번호 변경" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["Form"], { "validation-schema": $setup.schema }, {
          default: _withCtx(({ meta }) => [
            _createVNode($setup["ButtonInput"], {
              ref: "phoneNumberInput",
              class: "input-field",
              name: "newPhone",
              label: "휴대폰",
              type: "tel",
              placeholder: "숫자만 입력하세요",
              maxlength: 13,
              buttonTitle: $setup.verificationTitle,
              disabled: $setup.isVerificationSuccess,
              value: $setup.phoneNumber,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.phoneNumber) = $event)),
              onOnInput: $setup.onChangePhoneNumber,
              onOnClickButton: $setup.sendPhoneVerificationCode
            }, null, 8 /* PROPS */, ["buttonTitle", "disabled", "value", "onOnInput", "onOnClickButton"]),
            _createVNode($setup["ButtonInput"], {
              ref: "verificationInput",
              class: "input-field verification",
              name: "verification",
              label: "인증번호",
              type: "tel",
              disabled: 
            !$setup.didSendVerificationCode ||
            $setup.isVerificationSuccess ||
            $setup.isVerificationTimeOut
          ,
              maxlength: 6,
              errorMessage: $setup.verificationCodeErrorMessage,
              successMessage: $setup.verificationCodeSuccessMessage,
              placeholder: "인증번호를 입력하세요",
              buttonTitle: "확인",
              value: $setup.verificationCode,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.verificationCode) = $event)),
              onOnInput: $setup.onChangeVerificationCode,
              onOnClickButton: $setup.verifyCode
            }, {
              extraElement: _withCtx(() => [
                ($setup.remainingTimeStr)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.remainingTimeStr), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "errorMessage", "successMessage", "value", "onOnInput", "onOnClickButton"]),
            _createVNode($setup["BaseButton"], {
              class: "base-button",
              title: "변경",
              disabled: !(meta.valid && $setup.isVerificationSuccess),
              onOnClick: ($event: any) => (
            $setup.onClickChangePhoneNumber(meta.valid && $setup.isVerificationSuccess)
          )
            }, null, 8 /* PROPS */, ["disabled", "onOnClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["validation-schema"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}